import { makeVar, ReactiveVar } from '@apollo/client';

export type VersionGuardState = {
  isVersionOutdated: boolean;
};

type VersionGuardVar = ReactiveVar<VersionGuardState>;

export const versionGuardVar: VersionGuardVar = makeVar<VersionGuardState>({ isVersionOutdated: false });

export const updateIsVersionOutdated = (isVersionOutdated: boolean): VersionGuardState => {
  const currentVersionGuardVar = versionGuardVar();
  return versionGuardVar({ ...currentVersionGuardVar, isVersionOutdated });
};
